import { _namespaces } from "./_namespaces";
import { Namespace } from "./Namespace";
export function internNamespace(type, uri) {
    var key = type + uri;
    return _namespaces[key] || (_namespaces[key] = new Namespace(type, uri, ''));
}
